module.exports = __webpack_public_path__ + "static/media/movie-deadpool2.4a619dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/movies/movie-deadpool2.jpg
// module id = 29
// module chunks = 0